import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method apiGetConfig
 * @method apiGetBlob
 */

 export default {
    apiGetConfig: function (strConfig) {
        var params = {};

        var strUrl = Vue.bzbsConfig.bzbs_url + "/config/" + strConfig;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, null, params).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiGetBlob: function (partUrl) {
        var params = {};

        var strUrl = Vue.bzbsConfig.bzbs_blob_url + partUrl;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGetฺBlob(strUrl, null, params).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
 }